import { flare } from "@flareapp/flare-client";

if (process.env.NODE_ENV === 'production') {
    flare.light();
}

try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {}

